module.exports = __webpack_public_path__ + "img/c2.164cc83e.png";